import type {
  GetDataModelCatalogQuery,
  GetDataModelCatalogResponse,
  GetTableDetailsResponse,
} from "./dataModelCatalog.types";
import { MOCK_LATENCY_MS } from "./dataModels.constants";
import {
  SEED_CATALOG_METRICS,
  SEED_CATALOG_TABLES,
  buildTableDetailsResponse,
} from "./dataModelCatalog.mock";

export const mockFetchDataModelCatalog = async (
  query?: GetDataModelCatalogQuery,
): Promise<GetDataModelCatalogResponse> => {
  await new Promise((resolve) => setTimeout(resolve, MOCK_LATENCY_MS));

  const search = query?.search?.trim().toLowerCase();
  const entityType = query?.entityType ?? "all";

  let tables = [...SEED_CATALOG_TABLES];
  let metrics = [...SEED_CATALOG_METRICS];

  if (search) {
    tables = tables.filter((t) => t.name.toLowerCase().includes(search));
    metrics = metrics.filter((m) => m.name.toLowerCase().includes(search));
  }

  if (query?.sourceSystem) {
    tables = tables.filter((t) => t.source.id === query.sourceSystem);
  }

  const pageSize = query?.pageSize ?? 50;
  const data =
    entityType === "metric"
      ? { tables: [], metrics }
      : entityType === "table"
        ? { tables, metrics: [] }
        : { tables, metrics };

  return {
    data,
    meta: {
      pagination: {
        cursor: query?.cursor ?? null,
        nextCursor: null,
        pageSize,
        hasMore: false,
      },
    },
  };
};

export const mockFetchTableDetails = async (
  tableId: string,
): Promise<GetTableDetailsResponse> => {
  await new Promise((resolve) => setTimeout(resolve, MOCK_LATENCY_MS));
  const response = buildTableDetailsResponse(tableId);
  if (!response) {
    throw new Error(`Table not found: ${tableId}`);
  }
  return response;
};
